import { render } from "./companyIntro.vue?vue&type=template&id=b323a376"
import script from "./companyIntro.vue?vue&type=script&lang=js"
export * from "./companyIntro.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__